import {StateOperator} from '@ngxs/store';
import {append, patch} from '@ngxs/store/operators';
import {EntityState} from '../models/entity-state.model';

export const addEntity = (entity: any, idField = 'code'): StateOperator<EntityState<any>> => {
    return patch<EntityState<any>>({
        entities: patch({[entity[idField]]: entity}),
        codes: append([entity[idField]])
    });
};

export const upsertEntity = (entity: any, idField = 'code'): StateOperator<EntityState<any>> => {
    return (state) => {
        if (state.codes.includes(entity[idField])) {
            // update entity
            return {
                ...state,
                entities: {...state.entities, [entity[idField]]: entity}
            };
        }
        return addEntity(entity, idField)(state);
    };
};

